<template>
  <div class="mb-10">
    <v-card class="mt-2 mb-4 pa-4" color="#ebebeb" flat :loading="loading">
      <div class="d-flex flex-row flex-wrap justify-space-between align-center">
        <div>
          <div class="text-h5">{{ pageTitle }}</div>
          <div class="caption py-1" v-if="data && data.slug">
            /{{ data.slug }}

            <span v-if="data && data.slug && data.slug != ''"
              ><v-btn icon x-small @click="editSlugPrompt()"
                ><v-icon x-small color="primary">mdi-pencil</v-icon></v-btn
              ></span
            >
          </div>
        </div>
        <div>
          <!-- <v-btn depressed @click="doDelete()" color="red" text v-if="!newItem">
            Delete</v-btn
          > -->
          <v-btn depressed @click="exitPage()" class="mx-2" text> Cancel</v-btn
          ><v-btn
            :disabled="!valid"
            depressed
            color="primary"
            class="mx-2"
            @click="doSave()"
            text
          >
            Save</v-btn
          >
        </div>
      </div>

      <div class="caption d-flex flex-row flex-wrap align-center" v-if="data">
        <div class="mx-3" v-if="!newItem">id: {{ data.id }}</div>
        <div class="mx-3" v-if="data.added">Added: {{ data.added }}</div>
        <div class="mx-3" v-if="data.updated">Updated: {{ data.updated }}</div>
        <v-checkbox
          class="mx-3 my-0 py-0"
          v-model="data.display"
          dense
          :hide-details="true"
          label="Publish"
        ></v-checkbox>
      </div>
    </v-card>
    <v-alert type="warning" v-if="error">{{ error }}</v-alert>

    <v-form v-model="valid" v-if="data" class="mb-2" lazy-validation>
      <div class="d-flex flex-row flex-wrap">
        <div class="pr-md-4 pb-4">
          <div class="overline">Label</div>
          <v-text-field
            label="Title"
            v-model="data.name"
            outlined
            class=""
            @change="nameChange()"
            :rules="nameRules"
            required
          ></v-text-field>

          <v-select
            label="Section"
            v-model="data.section"
            :items="sectionOptions"
            outlined
            :rules="notNull"
            required
            class=""
          ></v-select>

          <v-select
            label="Category"
            v-model="data.category"
            :items="categoryOptions"
            :disabled="true"
            outlined
            :rules="notNull"
            required
            class=""
          >
            <!-- :disabled="!data.section" -->
          </v-select>
        </div>
        <div class="pr-md-4 pb-4">
          <div class="overline">
            Description (For lists)

            <v-btn
              class="ml-4"
              x-small
              rounded
              depressed
              outlined
              :disabled="!articlePopulated"
              @click="populateDescription()"
              color="primary"
              >Populate from article</v-btn
            >
          </div>
          <v-textarea
            v-model="data.description"
            label="Description"
            outlined
          ></v-textarea>
          <v-text-field
            label="Aliases (Words and phrases that make this article easier to search)"
            v-model="data.aliases"
            hide-details="auto"
            outlined
          ></v-text-field>
        </div>
        <div class="pr-md-4 pb-4 text-center" style="min-width: 350px">
          <div class="overline">Article Image (For lists)</div>
          <div class="d-flex flex-row justify-center">
            <v-scale-transition>
              <img v-if="data.image" :src="data.image" class="iconClass"
            /></v-scale-transition>
            <div>
              <v-btn
                x-small
                rounded
                depressed
                outlined
                color="primary"
                @click="openFileBrowser = true"
                class="ml-4"
                >{{ data.image ? "Replace" : "Add Image" }} </v-btn
              ><br />
              <v-fade-transition>
                <v-btn
                  x-small
                  rounded
                  depressed
                  outlined
                  color="warning"
                  @click="data.image = null"
                  class="ml-4"
                  v-if="data.image"
                  >Remove</v-btn
                >
              </v-fade-transition>
            </div>
          </div>
        </div>
      </div>

      <div class="overline mt-4">Article</div>
      <md-textarea
        v-model="data.article"
        height="600"
        style="width: 1000px; max-width: 95%"
      ></md-textarea>
    </v-form>

    <v-alert v-if="error">{{ error }}</v-alert>
    <v-snackbar v-model="updatedSnackbar" :timeout="2000" top color="success">
      {{ pageTitle }} Updated</v-snackbar
    >
    <v-snackbar v-model="deletedSnackbar" :timeout="2000" top color="alert">
      {{ pageTitle }} Deleted</v-snackbar
    >

    <file-browser
      :openDialog="openFileBrowser"
      dir="images/stories"
      @close="openFileBrowser = false"
      @fileSelected="addFile($event)"
    ></file-browser>
  </div>
</template>

<script>
// import Name from "../dir/file";
import ApiServices from "@/services/ApiServices";
import UserMixin from "@/assets/js/UserMixin";
import Slugify from "slugify";
import MdTextarea from "@/components/adminStuff/MdTextarea";
import FileBrowser from "@/components/adminStuff/FileBrowser";

export default {
  name: "EditArticle",
  components: {
    MdTextarea,
    FileBrowser,
  },
  mixins: [UserMixin],
  props: {
    slug: null,
    adminData: null,
  },
  data: function () {
    return {
      loading: false,
      pageTitle: "Add Article",
      //   apiPath: "/articles/addUpdate",
      newImageFiles: [], // t
      updatedSnackbar: false,
      deletedSnackbar: false,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length >= 6 || "Name must be at least characters",
      ],
      notNull: [(v) => !!v || "Category is required"],
      additionalFields: [
        {
          title: "Aliases",
          icon: "magnify",
          key: "aliases",
          type: "text",
          caption: "Keywords to make this condition easier to search for. ",
        },
      ],
      defaultData: {
        id: 0,
        name: "",
        slug: "",
        category: null,
        section: null,
        order: 99,
        image: null,
        description: null,
        aliases: null,
        article: null,
        display: 1,
        added: null,
        updated: null,
      },
      data: null,
      //   catsAndSects: null,
      //   selectedSection: null,
      valid: false,
      slugManuallyUpdated: false,
      openFileBrowser: false,
      eyedock: "https://www.eyedock.com",
      error: null,
    };
  },
  methods: {
    getData() {
      this.loading = true;
      if (!this.slug) return; // show error?
      this.error = null;
      ApiServices.article(this.slug, true) // admin = true
        .then((response) => {
          // this.data = response.data;
          if (response.data.article) {
            this.populateContentFromAPI(response.data.article);
            this.pageTitle = response.data.article.name;
            // this.catsAndSects = response.data.meta.sections;
            this.error = null;
            // this.apiPath = this.data.update_route;
          } else {
            this.error = "Article data not returned";
          }

          // this.emitPath();
        })
        .catch((error) => {
          console.log("error", error);
          //   this.data = null;
          if (error) this.error = "An API error occurred";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    populateDescription() {
      this.data.description = this.data.article.substring(0, 500);
    },
    exitPage() {
      this.$router.push({ path: "/boss/articles" });
    },
    doSave() {
      let api = this.crudAPI;
      if (!api) {
        this.error =
          "no api name available (should be returned with adminData api call)";
        console.log(
          "no api name available (should be returned with adminData api call)"
        );
        return;
      }
      this.loading = true;
      let data = { ...this.data };
      this.error = null;
      data.auth = this.auth_credentials;
      // console.log("calling" + this.apiPath);

      ApiServices.genericUpdateItem(api, data)
        .then((response) => {
          if (response.data.error) {
            this.error = response.data.error;
          } else if (response.data.success) {
            this.error = null;
            // this.$emit("edited", true);
            this.updatedSnackbar = true;
            this.exitPage();
          }
          // console.log(response);
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
        })
        .finally(() => {});
    },
    resetAll: function () {
      this.data = { ...this.defaultData };
      this.pageTitle = "Add Article";
    },
    populateContentFromAPI(data) {
      if (data?.display) data.display = parseInt(data.display);
      this.data = data;
    },

    nameChange() {
      if (this.data.name != "") this.pageTitle = this.data.name;
      if (!this.slugManuallyUpdated && this.newItem)
        this.updateSlug(this.data.name);
    },
    updateSlug(val) {
      if (val && this.data) {
        val = val.replace(/[()]/g, " ");
        this.data.slug = Slugify(val.toLowerCase());
      }
    },

    editSlugPrompt() {
      if (!this.data?.slug) return;
      let txt = "Choose a new vanity URL for item.";
      if (!this.newItem)
        txt +=
          "\n\nPlease be aware that changing the vanity URL will break any existing links to this item's listing! ";
      let newSlug = prompt(txt, this.data.slug);
      if (newSlug && newSlug != this.data.slug) {
        this.updateSlug(newSlug);
        this.slugManuallyUpdated = true;
      }
    },
    doDelete() {
      var confirmVar = confirm(
        "Are you sure you want to delete " +
          this.data.name +
          "? This cannot be undone"
      );
      if (confirmVar) {
        this.loading = true;
        let auth = this.auth_credentials;
        let data = { id: this.data.id, delete: true, auth: auth };
        // todo - consolidate this stuff with the doSave() method
        ApiServices.genericUpdateItem(this.apiPath, data)
          .then((response) => {
            if (response.data.error) {
              this.error = response.data.error;
            } else if (response.data.success) {
              this.error = null;
              // this.$emit("edited", true);
              this.deletedSnackbar = true;
              this.exitPage();
            }
          })
          .catch((error) => {
            console.log(error);
            this.error = error;
          })
          .finally(() => {});
      }
    },
    addFile(file) {
      if (!file || !file.path) return;
      // { "name": "biggrin.gif", "path": "/images/smilies/biggringif", "type": "gif" }
      this.data.image = this.eyedock + file.path;
    },
  },
  computed: {
    headerClass: function () {
      return this.$vuetify.breakpoint.smAndUp ? "bigHead" : "smallHead";
    },

    sectionOptions: function () {
      if (!this.adminData?.sections) return [];
      return Object.keys(this.adminData.sections);
    },
    categoryOptions: function () {
      if (!this.adminData?.sections || !this.data.section) return [];
      let cats = this.adminData.sections[this.data.section].categories;
      return Object.keys(cats);
    },
    newItem: function () {
      return this.slug == "new";
    },
    articlePopulated: function () {
      return this.data.article && this.data.article != "";
    },
    crudAPI: function () {
      return this.adminData?.admin_apis?.crud;
    },
  },
  watch: {},

  mounted() {
    if (!this.newItem) {
      this.getData();
    } else {
      // console.log("new item");
      this.resetAll(); // uses default data
    }
    // console.log("base", this.$router.options.base);
  },
  metaInfo() {
    return {
      title: "EyeDock Admin - Conditions " + this.pageTitle,
    };
  },
};
</script>

<style scoped>
.bigHead {
  min-width: 150px;
  max-width: 150px;
}
.bigHead {
  width: 100%;
}
.headerBkg {
  background-color: #e0f2ff;
  /* border-bottom: 1px solid #bfd5e5; */
  /* margin-bottom: -1px; */
}

.iconClass {
  max-width: 250px;
  max-height: 200px;
}
</style>
